import { DropdownFieldUI } from '@axo/form/feature/form-input/DropdownField/DropdownFieldUI';
import { useTranslation } from '@axo/shared/i18n';
import { Controller } from 'react-hook-form';
import { debtCreditorsOptions } from '../../../../../config/globals';
import { DebtFormGroupData } from '../../../../../FormData.dk.types';
import { requiredField } from '../../../../shared-config';

export const CreditorField = ({ index }: { index: number }) => {
  const { t } = useTranslation();

  return (
    <Controller
      name={`LoanApplication/Debts.${index}.Creditor`}
      render={({
        field: { name, value },
        fieldState: { error, invalid, isTouched },
      }) => {
        const fieldError = value ? undefined : error;
        const valid = !!value && !invalid && isTouched;

        if (!debtCreditorsOptions.some((option) => option.value === value)) {
          debtCreditorsOptions.push({ text: value, value });
        }

        return (
          <DropdownFieldUI<DebtFormGroupData>
            name={name}
            label={t('Debt.Creditor.label')}
            placeholder={t('placeholder')}
            data-testid={`debt-${index}-creditor`}
            options={debtCreditorsOptions}
            registerOptions={requiredField}
            error={fieldError}
            valid={valid}
          />
        );
      }}
    />
  );
};
